<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
  import { error, success } from "../../../../../public/my-theme";
  import type { Fn } from "../../../../global";
  import type { Denounced } from "../../../../Model/Denounced";
  import type { Third } from "../../../../Model/Third";
  import DenouncedInfoForm from "../../DenouncedInfoForm.svelte";
  import { denouncedGeneralService, denouncedService } from "../../../../services";
  import type { DenouncedGeneral } from "../../../../Model/DenouncedGeneral";
  import { select_value } from "svelte/internal";

  export let denouncedThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, denouncedThird)

  let size = "lg";
  let denounced: Denounced;
  let denouncedGeneral: DenouncedGeneral;

  const dispatch = createEventDispatcher();

  async function load(diligenceId, denouncedThird){
    if (diligenceId && denouncedThird) {

      denounced = await denouncedService.findOne(denouncedThird.id, diligenceId)

      if (denounced) {
        denouncedGeneral = await denouncedGeneralService.findOne(denouncedThird.id, diligenceId);
      }

    }
  }

  async function saveDenouncedTraffic() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    denounced.denouncedThirId = third.id;
    denouncedGeneral.denouncedThirId = third.id;
    save()
  }

  async function save(){
    await Promise.all([ 
      denouncedService.saveDenounced(denounced),
      denouncedGeneralService.saveDenouncedGeneral(denouncedGeneral)
    ])

    dispatch('saveDenounced');
  }


</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>

    <TabContent>
      <TabPane tabId="Datas" tab="Datos" active>
        {#if denounced}
          <DenouncedInfoForm denounced={denounced}  on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        {/if}
      </TabPane>
      {#if denouncedGeneral}
      <TabPane tabId="2" tab="Situación">
        <div class="mt-3">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-9 col-md-9">¿Quiere Declarar?</div>
                <div class="col-3 col-md-3">
                  <Input
                    type="select"
                    id="wantToDeclare"
                    value={denouncedGeneral.wantToDeclare ? 1 : 0}
                    on:change={(event) => {
                      denouncedGeneral.wantToDeclare = Boolean(
                        select_value(event.target)
                      );
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-9 col-md-9">¿Notifica a la familia?</div>
                <div class="col-3 col-md-3">
                  <Input
                    type="select"
                    id="wantToDeclare"
                    value={denouncedGeneral.familyNotice ? 1 : 0}
                    on:change={(event) => {
                      denouncedGeneral.familyNotice = Boolean(
                        select_value(event.target)
                      );
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-3">
              <div class="row">
                <div class="col-9 col-md-9">¿Examen médico?</div>
                <div class="col-3 col-md-3">
                  <Input
                    type="select"
                    id="wantToDeclare"
                    value={denouncedGeneral.medicalExamination ? 1 : 0}
                    on:change={(event) => {
                      denouncedGeneral.medicalExamination = Boolean(
                        select_value(event.target)
                      );
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-3">
              <div class="row">
                <div class="col-9 col-md-9">¿Necesita interprete?</div>
                <div class="col-3 col-md-3">
                  <Input
                    type="select"
                    id="interpreter"
                    value={denouncedGeneral.interpreter ? 1 : 0}
                    on:change={(event) => {
                      denouncedGeneral.interpreter = Boolean(
                        select_value(event.target)
                      );
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-3">
              <div class="row">
                <div class="col-9 col-md-9">¿Solicita Abogado?</div>
                <div class="col-3 col-md-3">
                  <Input
                    type="select"
                    id="wantToDeclare"
                    value={denouncedGeneral.appointLawyer ? 1 : 0}
                    on:change={(event) => {
                      denouncedGeneral.appointLawyer = Boolean(
                        select_value(event.target)
                      );
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-3">
              <div class="row">
                <div class="col-9 col-md-9">¿Abogado de Oficio?</div>
                <div class="col-3 col-md-3">
                  <Input
                    type="select"
                    id="wantToDeclare"
                    value={denouncedGeneral.publicDefender ? 1 : 0}
                    on:change={(event) => {
                      denouncedGeneral.publicDefender = Boolean(
                        select_value(event.target)
                      );
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
      
            <div class="col-12 mt-3">
              <Label for="mark">Parte Facultativo</Label>
              <Input
              type="textarea"
              id="optionalPart"
              rows={6}
              bind:value={denouncedGeneral.optionalPart}/>
            </div>
      
            <div class="col-12 col-md-6 mt-3">
              <div class="row">
                <div class="col-9 col-md-9">¿Poseé armas?</div>
                <div class="col-3 col-md-3">
                  <Input
                    type="select"
                    id="wantToDeclare"
                    value={denouncedGeneral.own_arms ? 1 : 0}
                    on:change={(event) => {
                      denouncedGeneral.own_arms = Boolean(
                        select_value(event.target)
                      );
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
      
            {#if denouncedGeneral.own_arms}
              <div class="col-12 mt-3">
                <Label for="mark">Tipo de Armas</Label>
                <Input
                type="textarea"
                id="optionalPart"
                rows={6}
                bind:value={denouncedGeneral.arms_types}/> 
              </div>
            {:else}
              <div class="col-md-6 mt-3"></div>
            {/if}
      
            <div class="col-12 col-md-6 mt-3">
              <div class="row">
                <div class="col-9 col-md-9">¿Conoce al denunciante?</div>
                <div class="col-3 col-md-3">
                  <Input
                    type="select"
                    id="wantToDeclare"
                    value={denouncedGeneral.meetWhistleblower ? 1 : 0}
                    on:change={(event) => {
                      denouncedGeneral.meetWhistleblower = Boolean(
                        select_value(event.target)
                      );
                    }}
                  >
      
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
      
            <div class="col-12 col-md-6 mt-3">
              <div class="row">
                <div class="col-9 col-md-9">¿Relación con el denunciante?</div>
                <div class="col-3 col-md-3">
                  <Input
                    type="select"
                    id="wantToDeclare"
                    value={denouncedGeneral.relationshipWithComplainant ? 1 : 0}
                    on:change={(event) => {
                      denouncedGeneral.relationshipWithComplainant = Boolean(
                        select_value(event.target)
                      );
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
          </div>
        </div>
      
      </TabPane>
      {/if}

    </TabContent>

  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveDenouncedTraffic}>Guardar</button>
  </ModalFooter>
</Modal>

